import { useCallback, useEffect, useState } from 'react';
import { OrderProperty } from 'types/order';
import { LEDGER_CODE_LOAN_AMOUNT, LEDGER_CODE_PURCHASE_PRICE } from 'utils/constants';

type Params = {
	properties: OrderProperty[]
};

export const useInformationBar = ({ properties }: Params) => {
  const [showPropertyList, setShowPropertyList] = useState(false);
  const [selectedProperty, setSelectedProperty] = useState<{
		address: string,
		loanAmount: number | undefined,
		purchasePrice: number | undefined
	}>({ address: '', loanAmount: undefined, purchasePrice: undefined });

  const selectProperty = useCallback(({ property }: { property: OrderProperty }) => {
    const { address } = property.address;
    const loanAmountEntry = property?.accounting?.find((entry) => entry.code.includes(LEDGER_CODE_LOAN_AMOUNT));
    const purchasePriceEntry = property?.accounting?.find((entry) => entry.code.includes(LEDGER_CODE_PURCHASE_PRICE));
    const loanAmountValue = loanAmountEntry?.amount;
    const purchasePriceValue = purchasePriceEntry?.amount;

    setSelectedProperty({
      address,
      loanAmount: loanAmountValue,
      purchasePrice: purchasePriceValue
    });
  }, []);

  useEffect(() => {
    if (properties.length > 0) {
      const sortedProperties = [...properties].sort((propertyA, propertyB) => (
        propertyA.address.address.localeCompare(propertyB.address.address)
      ));
      selectProperty({ property: sortedProperties[0] });
    } else if (selectedProperty.address) {
      setSelectedProperty({ address: '', loanAmount: undefined, purchasePrice: undefined });
    }
    // Seeds the selection only when the property list changes; adding selectProperty/address would re-select on every user pick.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [properties]);

  return {
    showPropertyList,
    setShowPropertyList,
    selectedProperty,
    selectProperty
  };
};
